export default __webpack_public_path__ + "icons-solid.png";